import React from "react";
import {
  EditBlock,
  Info,
  InfoColumn,
  InfoRow,
  SimpleHeader,
} from "../styled/texts";
import { HorizontalGap, VerticalGap } from "../styled/gaps";
import EditIcon from "@mui/icons-material/Edit";

const TabInfo = (props) => {
  return (
    <InfoRow>
      <InfoColumn>
        <SimpleHeader>{props.header}</SimpleHeader>
        <VerticalGap size={"10px"} />
        <Info>{props.desc}</Info>
      </InfoColumn>
      {props.editIcon ? (
        <EditBlock onClick={props.editHandler}>
          {" "}
          <EditIcon /> <HorizontalGap size={"5px"} /> <div>Edit</div>
        </EditBlock>
      ) : null}
    </InfoRow>
  );
};

export { TabInfo };
